import Image from 'next/image';
import TradeVolume from './trade_volume';

const Intro = () => {
  return (
    // <!-- Intro -->
    <section className='bg-gradient-to-r from-[transparent_33%] to-[#F5F8FA_33%] py-12 dark:to-[#101436_33%]'>
      <div className='container'>
        <div className='lg:flex lg:justify-between'>
          {/* <!-- Image --> */}
          <div className='relative lg:w-[45%]'>
            <figure className='relative'>
              <img src='/images/img_dao.jpg' className='rounded-2.5xl' alt='web protocol' />
            </figure>
          </div>

          {/* <!-- Info --> */}
          <div className='py-10 lg:w-[55%] lg:pl-24'>
            <h2 className='mb-6 font-display text-3xl text-jacarta-700 dark:text-white'>
              Ever-increasing collections
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              Bit5 is a platform where many users and NFT collection owners come together as it
              offers different features for both users and collection owners than other NFT
              marketplaces.
            </p>
            {/* <p className='dark:text-jacarta-300'>
              Therefore, NFT platforms or the NFT marketplace cannot be centralized. However, the
              founders of the blockchain protocol have sovereignty over decisions such as launching
              features on the blockchain, establishing rules, and unveiling upgrades.
            </p> */}
            <TradeVolume />
          </div>
        </div>
      </div>
    </section>
    // <!-- end intro -->
  );
};

export default Intro;
